module.exports = __webpack_public_path__ + "static/img/bottom_bj.70f3a9e2.png";